import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { AppContextProvider } from './Context/AppContext';
import { FeatureFlagProvider } from './Context/FeatureFlagContext';
import CustomRouterPrompt from './Navigation/AdminRouter/CustomRouterPrompt/CustomRouterPrompt';

export const history = createBrowserHistory({});

ReactDOM.render(
  <Router history={history} getUserConfirmation={CustomRouterPrompt}>
    <ErrorBoundary>
      <AppContextProvider>
        <FeatureFlagProvider>
          <App />
        </FeatureFlagProvider>
      </AppContextProvider>
    </ErrorBoundary>
  </Router>,
  document.getElementById('root')
);
